import PQueue from "p-queue"

const pQueue = new PQueue({ concurrency: 5 })

const RoomSyncQueue = {
  enqueue(fn: () => Promise<any>, id?: string) {
    if (id) {
      console.log(
        `[RoomSyncQueue] Enqueued ${id} (waiting: ${pQueue.size + 1}, running: ${pQueue.pending})`,
      )
    }

    const wrapped = async () => {
      if (id) {
        console.log(
          `[RoomSyncQueue] Started ${id} (waiting: ${pQueue.size}, running: ${pQueue.pending})`,
        )
      }
      try {
        return await fn()
      } finally {
        if (id) {
          console.log(
            `[RoomSyncQueue] Finished ${id} (waiting: ${pQueue.size}, running: ${pQueue.pending - 1})`,
          )
        }
      }
    }

    return pQueue.add(wrapped, id ? { id, priority: 0 } : {})
  },
  prioritize(jid: string) {
    try {
      pQueue.setPriority(jid, 1)
      console.log(
        `[RoomSyncQueue] Reprioritized ${jid} (waiting: ${pQueue.size}, running: ${pQueue.pending})`,
      )
    } catch {
      // no-op: room is in-flight, already synced, or never enqueued
    }
  },
  clear() {
    console.log(
      `[RoomSyncQueue] Cleared (waiting: ${pQueue.size}, running: ${pQueue.pending})`,
    )
    pQueue.clear()
  },
}

export default RoomSyncQueue
